/**
 * Created by i.lovenkov on 18.11.16.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    CheckAuth: {
        displayName: 'CheckAuth'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/CheckAuth/CheckAuth.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var CheckAuth = _wrapComponent('CheckAuth')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        user: state.auth.user
    };
}, { pushState: _reactRouterRedux.push }), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(CheckAuth, _Component);

    function CheckAuth() {
        (0, _classCallCheck3.default)(this, CheckAuth);
        return (0, _possibleConstructorReturn3.default)(this, (CheckAuth.__proto__ || (0, _getPrototypeOf2.default)(CheckAuth)).apply(this, arguments));
    }

    (0, _createClass3.default)(CheckAuth, [{
        key: 'render',
        value: function render() {
            if (!this.props.user) {
                this.props.pushState('/');
                return null;
            }

            return _react3.default.createElement(
                'div',
                null,
                this.props.children
            );
        }
    }]);
    return CheckAuth;
}(_react2.Component), _class2.propTypes = {
    children: _react2.PropTypes.node,
    pushState: _react2.PropTypes.func.isRequired,
    user: _react2.PropTypes.object
}, _temp)) || _class));

exports.default = CheckAuth;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/CheckAuth/CheckAuth.jsx
// module id = 1809
// module chunks = 0